import React from "react";

export const Features = (props) => (
  <div id="features" className="text-center">
    <div className="container">
      <div className="col-md-10 col-md-offset-1 section-title">
        <h2>Why Buyers Come to Oman for Stone — and to Us</h2>
        <p>
          Oman sits on some of the finest beige and cream marble in the region, on
          shipping lanes that reach three continents. We are the part of that story
          that owns the rock.
        </p>
      </div>
      <div className="card-grid cols-4">
        {props.data
          ? props.data.map((d, i) => (
              <div key={`${d.title}-${i}`} className="feature-item">
                <i className={d.icon}></i>
                <h3>{d.title}</h3>
                <p>{d.text}</p>
              </div>
            ))
          : "Loading..."}
      </div>
    </div>
  </div>
);
